import apiCarteira from "api/api-carteira";
import { VendeAIService } from "./types";
import { Dispatch, SetStateAction } from "react";
import apiDigitacao from "api/api-digitacao";
import { Toast } from "components/toast";
import { getErrorMessage } from "utils/util";
import { sortArrayBy } from "utils/filter-array-by";

export class VendeAIAPI {
  constructor(private customerId: number) {}

  public async changeBanco(defaultBank: string) {
    return await apiCarteira.put(
      `/services/ia-vendeai/${this.customerId}/default-bank`,
      { defaultBank }
    );
  }
  async getDefaultBank() {
    return await apiCarteira.get<VendeAIService>(
      `/services?customer_id=${this.customerId}&servico=IA_VENDEAI`
    );
  }

  async getBanks({
    setLoading,
    setBancos,
    onClose,
    setBancosNaoConfigurados,
  }: {
    setLoading?: Dispatch<SetStateAction<boolean>>;
    setBancos: Dispatch<SetStateAction<{ banco: string }[]>>;
    setBancosNaoConfigurados: Dispatch<SetStateAction<string[]>>;
    onClose: () => void;
  }) {
    setLoading?.(true);
    try {
      const { data } = await apiDigitacao.get<{
        bancos: string[];
        bancosNaoConfigurados: string[];
      }>(
        `/api/tabelas-digitacao/vendeai/prioridade-bancos?customer_id=${this.customerId}`
      );
      const bancos = data.bancos.map((banco, i) => ({ banco, ordem: i + 1 }));
      if (!bancos.length) {
        Toast({ title: "Não há bancos para configurar.", status: "info" });
        onClose();
      }
      setBancos(bancos);
      setBancosNaoConfigurados(data.bancosNaoConfigurados);
    } catch (e) {
      Toast({ title: `Erro ao obter bancos` });
      onClose();
    } finally {
      setLoading?.(false);
    }
  }

  async changeBancos({
    setLoading,
    bancos,
    onClose,
    setBancos,
    setBancosNaoConfigurados,
    desconfigurarBancos,
  }: {
    setLoading: Dispatch<SetStateAction<boolean>>;
    setBancos: Dispatch<SetStateAction<{ banco: string }[]>>;
    setBancosNaoConfigurados: Dispatch<SetStateAction<string[]>>;
    bancos: { banco: string }[];
    onClose: () => void;
    desconfigurarBancos: string[];
  }) {
    const parsedBancos = bancos.map(({ banco }) => banco);

    setLoading(true);
    try {
      const { data } = await apiDigitacao.patch<{
        bancos: string[];
        bancosNaoConfigurados: string[];
      }>(
        `/api/tabelas-digitacao/vendeai/prioridade-bancos?customer_id=${this.customerId}`,
        { bancos: parsedBancos, desconfigurarBancos }
      );
      const bancos = data.bancos.map((banco, i) => ({ banco, ordem: i + 1 }));

      setBancos(bancos);
      setBancosNaoConfigurados(data.bancosNaoConfigurados);
      onClose();
    } catch (error: any) {
      Toast({
        title: "Erro ao alterar banco.",
        description: getErrorMessage({ error, defaultMessage: "" }),
      });
    } finally {
      setLoading(false);
    }
  }
}
